// extracted by mini-css-extract-plugin
export default {"report":"userSingleReport_report__0nWfF"};